/**
 * Created by dhavaljoshi on 29/08/17.
 */

define(function (require, exports, module) {

  'use strict';

  exports.preventNonSwiftChar = function(){
    return {
      restrict: 'AE',
      require: 'ngModel',
      link: function(scope, element, attrs, ctrl) {

        element.on('keypress', function(e) {
          var char = e.char || String.fromCharCode(e.charCode);

          if (/[^A-Za-z0-9ŚŹśźŁĄŻłążĆĘŃÓćęńó :?.,+()'/-]+/g.test(char)) {
            e.preventDefault();
            return false;
          }
        });

        element.on('paste', function(e) {
          var char='';
          if (window.clipboardData && window.clipboardData.getData) { // IE
              char = window.clipboardData.getData('Text');
          }
          else if (e.originalEvent.clipboardData && e.originalEvent.clipboardData.getData) { // other browsers
              char = e.originalEvent.clipboardData.getData('text/plain');
          }
          if (/[^A-Za-z0-9ŚŹśźŁĄŻłążĆĘŃÓćęńó :?.,+()'/-]+/g.test(char)) {
            e.preventDefault();
            return false;
          }
        });
      }
    };
  };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/portal/preventnonswiftchar.js
// module id = 13
// module chunks = 0